import { render, staticRenderFns } from "./SurveyDone.vue?vue&type=template&id=bf17bb98&scoped=true"
import script from "./SurveyDone.vue?vue&type=script&lang=js"
export * from "./SurveyDone.vue?vue&type=script&lang=js"
import style0 from "./SurveyDone.vue?vue&type=style&index=0&id=bf17bb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf17bb98",
  null
  
)

export default component.exports